// React
import React, { Component } from 'react';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Title from 'components/TitleWithIcon';
import FiltrosEstadisticasSolicitudes from './Filtros/index'
import TabMenu from '../MenuListadoReportes'

class EstadisticasSolicitudes extends Component {     
    constructor(props) {
        super(props);
        this.state = {

        }
    //declaraciones de todas las funciones que se utilizaran
    }
    render() {
        return (
            <TabMenu
                componenteEntrante={
                    <div>
                        <Title title={'Estadísticas de Solicitudes para Supervisores'} icon={"/menu/Estadistica.png"}/>
                        <FiltrosEstadisticasSolicitudes />
                    </div>
                }
            /> 
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EstadisticasSolicitudes);